import React from 'react'

const Copyright = () => {
  return (
    <p className="text-white">© {new Date().getFullYear()} Sceme. Powered by <a href="https://sceme.io" rel={"noreferrer"} className='font-weight-bold text-white' target="_blank">Sceme.io</a></p>
  )
}

export default Copyright